import { render, staticRenderFns } from "./Article11.vue?vue&type=template&id=8e166778&"
import script from "./Article11.vue?vue&type=script&lang=js&"
export * from "./Article11.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports